/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Calendar, Typography, Radio, Divider, Input, Tooltip, Popover } from 'antd';
import { CalendarOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import './index.scss';

function CustomCalendar({ setYear, year }) {
  // const [year, setYear] = useState(null);
  const [currentYear, setCurrentYear] = useState(null);
  const [previousYear, setPreviousYear] = useState(null);
  const [tooltipValidationOpen, setTooltipValidationOpen] = useState(false);

  function generateRandomString(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const nextCheck = () => {
    setCurrentYear(currentYear + 11);
  };
  const previousCheck = () => {
    setCurrentYear(currentYear - 11);
  };

  const onChangeRadio = (e) => {
    setYear(e.target.value);
    setTooltipValidationOpen(!tooltipValidationOpen);
  };

  const headerCheek = (valuee) => {
    let options = [];
    const finalOptions = [];
    let count = 0;
    if (currentYear === null) {
      setCurrentYear(valuee?.value?.year());
    }
    setPreviousYear(currentYear - 11);
    const randomString2 = generateRandomString(5); // Generates a 5-character random string
    let keyName = randomString2;
    for (let wew = currentYear - 11; wew <= currentYear; wew += 1) {
      const fyEnd2 = String(wew + 1).slice(-2);
      options.push(
        <Radio.Button
          id={keyName}
          style={{ width: '100px', border: 'none', position: 'initial' }}
          value={wew}
        >
          {wew}-{String(fyEnd2).slice(-2)}
        </Radio.Button>
      );
      count += 1;
      if (count === 3) {
        count = 0;
        const randomString3 = generateRandomString(5); // Generates a 5-character random string
        keyName = randomString3;
        finalOptions.push(options);
        options = [];
      }
    }

    finalOptions.push(options);
    return (
      <div style={{ width: '300px' }}>
        <div className="custom-header">
          <Button icon={<LeftOutlined />} onClick={previousCheck} />
          <Typography.Text style={{ fontSize: '14px', fontWeight: '600' }}>
            {previousYear}-{currentYear}
          </Typography.Text>
          <Button icon={<RightOutlined />} onClick={nextCheck} />
        </div>
        <Divider />

        <Radio.Group
          onChange={(e) => onChangeRadio(e)}
          value={year}
          buttonStyle="solid"
          style={{ textWrap: 'wrap' }}
        >
          {finalOptions}
        </Radio.Group>
      </div>
    );
  };

  const handleOpenChange = () => {
    setTooltipValidationOpen(!tooltipValidationOpen);
  };

  const onChange = (val) => {
    setYear(val);
  };
  // useEffect(() => {
  //   if (year && tooltipValidationOpen) {
  //     setTooltipValidationOpen(!tooltipValidationOpen);
  //   }
  // }, [year, tooltipValidationOpen]);

  return (
    <Popover
      placement="bottomLeft"
      open={tooltipValidationOpen}
      onOpenChange={handleOpenChange}
      trigger="click"
      style={{ width: '27%%' }}
      content={
        <Calendar
          style={{
            width: '100%',
            margin: '12px 0'
          }}
          mode="year"
          size="middle"
          onChange={(val) => onChange(val)}
          headerRender={(value) => headerCheek(value)}
          format={(actualDate) => {
            if (!actualDate) return '';
            const fyStart = actualDate.year();
            const fyEnd = String(fyStart + 1).slice(-2);
            return `${fyStart}-${fyEnd}`;
          }}
          className="custom-fy-calendar"
        />
      }
    >
      <Input
        placeholder="Select Year"
        value={year ? `${year}-${String(year + 1).slice(-2)}` : ''}
        suffix={<CalendarOutlined />}
        readOnly
        onClick={() => setTooltipValidationOpen(!tooltipValidationOpen)}
      />
    </Popover>
  );
}

CustomCalendar.propTypes = {
  setYear: PropTypes.func.isRequired,
  year: PropTypes.number
};
CustomCalendar.defaultProps = {
  year: null
};
export default CustomCalendar;
